'use client';

import { useSafeNavigation } from '@/hooks/useSafeNavigation';
import ServiceHeader from '@/components/layout/service/ServiceHeader';
import {
    BLUE_BOARD_GUIDE_DATA,
    contentCdMap,
} from '@/(routers)/(contentset)/hello-schoomy/api-guide/components/data/BlueBoardGuide';

export default function BlueBoardGuideIndex() {
    const { safePush } = useSafeNavigation();
    const reverseContentCdMap = Object.fromEntries(Object.entries(contentCdMap).map(([key, value]) => [value, key]));

    return (
        <>
            <ServiceHeader title="HELLO SCHOOMY." />
            <div className="flex justify-center w-full py-2">
                <div className="flex flex-col justify-center items-start w-full md:w-[98%]">
                    <div className="flex flex-col justify-start items-center bg-color-white-base w-full pt-2 pb-4 section-4-b">
                        <ul className="w-full px-4">
                            {BLUE_BOARD_GUIDE_DATA.map(({ contentsCd, codeBlockOverView }) => {
                                const contentType = reverseContentCdMap[contentsCd];
                                return (
                                    <div
                                        key={contentsCd}
                                        className="border-b cursor-pointer py-8"
                                        onClick={() => {
                                            safePush(`/hello-schoomy/api-guide/s1/${contentType}`);
                                        }}
                                    >
                                        <div className="font-corp font-bold text-xl text-color-base hover:underline underline-offset-2">
                                            {codeBlockOverView.blockName}
                                        </div>
                                        <div className="section-spacer-inner-y"></div>
                                        <div className="font-notojp font-medium text-xs text-color-co-gray-dark">
                                            {codeBlockOverView.description}
                                        </div>
                                    </div>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
